import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GateContabilita } from "./GateContabilita"; // <-- verifica il path/nome file

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GateContabilita>
      <App />
    </GateContabilita>
  </React.StrictMode>
);
